<mat-toolbar class="nav-toolbar"
  fxLayoutAlign="center stretch"
  fxLayout="column"
  fxLayoutGap="4px">

  @if (!isSmaller) {
    <div
      mat-button
      fxLayout="row"
      class="nav-logo">
      <div class="logo"
        [ngStyle]="getSubscriptionLogo()">
      </div>
    </div>
  } @else {
    <div mat-button
      fxLayout="row"
      class="small-nav-logo">
      <div class="logo"
        [ngStyle]="getSubscriptionLogo()">
      </div>
    </div>
  }


  @if (showAppName) {
    <span class="app-name secondary-text mat-h3"
    fxLayoutAlign="center"> {{ appName }}</span>
  }

</mat-toolbar>